import client from '../../client';

const SALES = {
  getSales(params) {
    return client.get(`/sellers/${client.customerId()}/sales`, params);
  },

  getSale(saleId) {
    return client.get(`/sellers/${client.customerId()}/sales/${saleId}`);
  },

  updateSale(saleId, params) {
    return client.put(`/sellers/${client.customerId()}/sales/${saleId}`, { sale: params });
  },

  getPublicationData(saleId) {
    return client.get(`/sellers/${client.customerId()}/sales/${saleId}/publication_data`);
  },
}

export default SALES;
